"use client";
import { Link } from "@/i18n/routing";
import { cn } from "@/lib/utils/utils";

type Props = {
  href: string;
  title: string;
  isActive?: boolean;
};

export default function NavbarMenuItemLink({ href, title, isActive }: Props) {
  return (
    <Link
      href={href}
      aria-label={title}
      className="text-lg lg:text-xl hover:[&>div]:h-4 hover:[&>div]:overflow-y-visible text-secondary-foreground hover:text-secondary  flex flex-col justify-between items-center  gap-2 h-full relative overflow-hidden"
    >
      {title}

      <div
        className={cn(
          "flex justify-center items-center w-3 border-r-secondary border-l-secondary  border-l border-r h-0 overflow-y-hidden  absolute bottom-0 transition-all duration-300 ease-in-out",
          isActive && "h-4 overflow-y-visible",
        )}
      >
        <div className="w-0.5 h-6 bottom-0 bg-primary absolute " />
      </div>
    </Link>
  );
}
